/**
 * Coasting Physics Calculations
 *
 * Simplified to only contain calculations not already done by backend.
 * Acceleration and lean angles come from ProcessedTelemetryData.
 */

import type { VehicleStrategy } from './vehicles/VehicleStrategy'
import { type CoastingConfig } from './types'

/**
 * Calculate combined g-force from lateral and longitudinal components.
 */
export const calculateCombinedGForce = (
  leanAngleDegrees: number,
  accelerationMs2: number
): number => {
  const absLeanAngle = Math.abs(leanAngleDegrees)
  const lateralG = Math.tan((absLeanAngle * Math.PI) / 180)
  const longitudinalG = Math.abs(accelerationMs2) / 9.81
  const combinedG = Math.sqrt(
    lateralG * lateralG + longitudinalG * longitudinalG
  )

  return combinedG
}

export const calculateCoastingIntensity = (
  acceleration: number,
  leanAngle: number | undefined,
  _config: CoastingConfig,
  speed: number,
  vehicleStrategy: VehicleStrategy
): number => {
  const absLeanAngle = Math.abs(leanAngle ?? 0)
  const combinedG = calculateCombinedGForce(absLeanAngle, acceleration)
  const lateralG = Math.tan((absLeanAngle * Math.PI) / 180)

  return vehicleStrategy.calculateCoastingIntensity(
    acceleration,
    absLeanAngle,
    lateralG,
    combinedG,
    speed
  )
}
